"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-bitwise */
const errors_1 = require("@ledgerhq/errors");
const logs_1 = require("@ledgerhq/logs");
const getVersion_1 = __importDefault(require("./getVersion"));
const isDevFirmware_1 = __importDefault(require("./isDevFirmware"));
const getAppAndVersion_1 = __importDefault(require("./getAppAndVersion"));
const provider_1 = require("../manager/provider");
const isDashboardName_1 = require("./isDashboardName");
const errors_2 = require("../errors");
const ManagerAllowedFlag = 0x08;
const PinValidatedFlag = 0x80;
function getDeviceInfo(transport) {
    return __awaiter(this, void 0, void 0, function* () {
        const probablyOnDashboard = yield (0, getAppAndVersion_1.default)(transport)
            .then(({ name }) => (0, isDashboardName_1.isDashboardName)(name))
            .catch(e => {
            if (e instanceof errors_1.TransportStatusError) {
                // @ts-expect-error typescript not checking agains the instanceof
                if (e.statusCode === 0x6e00) {
                    return true;
                }
                // @ts-expect-error typescript not checking agains the instanceof
                if (e.statusCode === 0x6d00) {
                    return false;
                }
            }
            throw e;
        });
        if (!probablyOnDashboard) {
            throw new errors_1.DeviceOnDashboardExpected();
        }
        const res = yield (0, getVersion_1.default)(transport).catch(e => {
            if (e instanceof errors_1.TransportStatusError) {
                // @ts-expect-error typescript not checking agains the instanceof
                if (e.statusCode === 0x6d06 || e.statusCode === 0x6d07) {
                    throw new errors_2.DeviceNotOnboarded();
                }
            }
            throw e;
        });
        const { isBootloader, rawVersion, targetId, seVersion, seTargetId, mcuBlVersion, mcuVersion, mcuTargetId, flags, bootloaderVersion, hardwareVersion, languageId, } = res;
        const isOSU = rawVersion.includes("-osu");
        const version = rawVersion.replace("-osu", "");
        const m = rawVersion.match(/([0-9]+.[0-9]+)(.[0-9]+)?(-(.*))?/);
        const [, majMin, , , postDash] = m || [];
        const providerName = provider_1.PROVIDERS[postDash] ? postDash : null;
        const flag = flags.length > 0 ? flags[0] : 0;
        const managerAllowed = !!(flag & ManagerAllowedFlag);
        const pinValidated = !!(flag & PinValidatedFlag);
        let isRecoveryMode = false;
        let onboarded = true;
        if (flags.length === 4) {
            // Nb Since LNS+ unseeded devices are visible + extra flags
            isRecoveryMode = !!(flags[0] & 0x01);
            onboarded = !!(flags[0] & 0x04);
        }
        (0, logs_1.log)("hw", "deviceInfo: se@" +
            version +
            " mcu@" +
            mcuVersion +
            (isOSU ? " (osu)" : isBootloader ? " (bootloader)" : ""));
        const hasDevFirmware = (0, isDevFirmware_1.default)(seVersion);
        return {
            version,
            mcuVersion,
            seVersion,
            mcuBlVersion,
            majMin,
            providerName: providerName || null,
            targetId,
            hasDevFirmware,
            seTargetId,
            mcuTargetId,
            isOSU,
            isBootloader,
            isRecoveryMode,
            managerAllowed,
            pinValidated,
            onboarded,
            bootloaderVersion,
            hardwareVersion,
            languageId,
        };
    });
}
exports.default = getDeviceInfo;
//# sourceMappingURL=getDeviceInfo.js.map